import { useState, Fragment, useEffect } from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { Heading, Paragraph } from "../../components/UI/Typoraphy";
import { CheckBox, Button, List } from "../../components/UI";
import { mq } from "../../components/responsive";

import MapIcon from "../../assets/map.svg";
import * as api from "../../utils/api";

const locations = [
  { id: 1, name: "Tien Giang", types: [""] },
  { id: 2, name: "Ben Tre", types: [""] },
  { id: 3, name: "Sai Gon", types: [""] },
  { id: 4, name: "Soc Trang", types: [""] },
];

const FilterGroup = styled.div({
  marginBottom: "2rem",
});

function Filter({
  handleClear,
  handleApply,
  q: currentQ = "",
  expand,
  handleFilterChange,
  filters,
}) {
  const [focus, setFocus] = useState(false);
  const [q, setQ] = useState(currentQ);
  const [selected, setSelected] = useState({});
  const [suggestions, setSuggestions] = useState(locations);

  useEffect(() => {
    // Get suggestions from API

    if (q) {
      const value = q.trim();
      const fetchSuggestions = async (value) => {
        try {
          const { data } = await api.fetchSuggestions(q);
          if (data.status === "success") setSuggestions(data.data.suggestions);
        } catch (e) {
          console.log(e);
        }
      };
    }
  }, [q]);

  const handleFocus = () => setFocus(true);
  const handleQChange = (e) => setQ(e.target.value);

  const handleChooseSuggestion = (event, suggestion) => {
    event.stopPropagation();
    setSelected(suggestion);
    setQ(suggestion.name);
    setFocus(false);
  };

  return (
    <div
      css={{
        transform: expand ? "none" : "translateX(120%)",
        position: expand ? "relative" : "absolute",
        transition: "transform 0.25s ease-in-out",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "#ffffff",
        height: "100%",
        right: 0,
        top: 0,
        transformOrigin: "right",
        width: expand ? "100%" : 0,
        overflow: "hidden",

        [mq.xl]: {
          padding: "4rem 0",
          transform: expand ? "none" : "translateX(-120%)",
        },
      }}
    >
      <div>
        <Heading level={4} style={{ marginBottom: "2rem" }}>
          Filter:
        </Heading>
        <FilterGroup>
          <input
            autoComplete="off"
            type="text"
            onFocus={handleFocus}
            onChange={handleQChange}
            value={q}
            placeholder="Where to?"
            css={{
              padding: "2rem",
              WebkitAppearance: "none",
              borderRadius: "3rem",
              border: "none",
              boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.06)",
              outline: "none",
              fontSize: "2rem",
              width: "100%",
            }}
          />
        </FilterGroup>
        {focus ? (
          <Fragment>
            <Paragraph
              style={{
                display: "flex",
                cursor: "poniter",
                marginBottom: "3rem",
                color: "#50976A",
              }}
            >
              <img
                src={MapIcon}
                alt="map-icon"
                css={{ marginRight: "2rem", width: "3rem" }}
              />
              Explore nearby destination
            </Paragraph>
            <List>
              {suggestions.map((suggestion) => (
                <List.Item
                  key={suggestion.id}
                  style={{ margin: "1.5rem 0" }}
                  onClick={(event) => handleChooseSuggestion(event, suggestion)}
                >
                  <Paragraph style={{ color: "#939DA9", cursor: "pointer" }}>
                    <i
                      className="fas fa-map-marker-alt"
                      style={{
                        marginRight: "2rem",
                        color: "#333",
                        width: "3rem",
                        textAlign: "center",
                      }}
                    ></i>
                    {suggestion.name}
                  </Paragraph>
                </List.Item>
              ))}
            </List>
          </Fragment>
        ) : (
          <Fragment>
            {Object.values(filters).map((filter) => (
              <FilterGroup key={filter.name}>
                <Paragraph>{filter.title}</Paragraph>
                <CheckBox
                  display="flex"
                  overflowX="auto"
                  options={filter.options.map((option) => ({
                    ...option,
                    selected: filter.value.includes(option.value),
                  }))}
                  onChange={(options) =>
                    handleFilterChange(
                      filter.name,
                      options.map((option) => option.value)
                    )
                  }
                  single={filter.single}
                />
              </FilterGroup>
            ))}
          </Fragment>
        )}
      </div>
      <div
        css={{
          display: "flex",
          justifyContent: "space-evenly",
          width: "100%",
          background: "white",
          zIndex: 2,
          paddingBottom: "1rem",
          paddingTop: "1rem",

          [mq.xl]: {
            justifyContent: "flex-start",

            "& > *:first-of-type": {
              marginRight: "7rem",
            },
          },
        }}
      >
        <Button type="secondary" onClick={handleClear}>
          Clear
        </Button>
        <Button onClick={() => handleApply(selected)}>Apply</Button>
      </div>
    </div>
  );
}

export default Filter;
